import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { DataService } from 'src/app/_services/data.service';
import { Subscription } from 'rxjs';

import 'codemirror/lib/codemirror';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/mode/python/python';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/matchbrackets';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';


@Component({
  selector: 'app-manage-python-script',
  templateUrl: './manage-python-script.component.html',
  styleUrls: ['./manage-python-script.component.scss']
})
export class ManagePythonScriptComponent implements OnInit {

  pythonManageForm: UntypedFormGroup;
  //subscription: Subscription;
  projectName: any;
  submitted = false;
  title: any;
  projectId: string;
  testData: any;
  projectData: any = {};
  public searchString: string;
  executionMode = ["Sequential", "Parallel"];
  default = 'default';
  updateForm: boolean = false;
  scriptDataById: any;
  editorOptions = {
    theme: 'eclipse',
    mode: 'python',
    lineNumbers: true,
    lineWrapping: true,
    foldGutter: true,
    autoCloseBrackets: true,
    matchBrackets: true,
    extraKeys: { 'Ctrl-Space': "autocomplete" }
  }
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Manage Python Script',
    data: undefined,
  }
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  agentCheck: boolean;

  constructor(
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private router: Router,
    private urlService: UrlService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    private confirmationDialogService: ConfirmationDialogService) {
  }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
      //  this.getProjectData();
        this.getTestData();
       setTimeout(() => {
        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
          }
        ))
      }, 0)
      }
    )
    this.loadForm();
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  // getProjectData() {
  //   this.subscription = this.project.getProjectDetails().subscribe((res) => {
  //     this.projectData = res;
  //   })
  // }

  getTestData() {
    this.dataService.getPythonTestData(this.projectId).subscribe(
      (data) => {
        this.testData = data['pythonscriptData'];
      });
  }

  delRow(id) {
    this.confirmationDialogService.openConfirmDialog('Do you want to delete ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.dataService.deletePythonTestData(this.projectId, id).subscribe(
            (data) => {
              this.getTestData();
              this.updateForm = false;
              this.toastrService.clear();
              this.toastrService.success('Python Scripts Deleted Successfully');
              this.ClearForm();
            }
          );
        }
      });
  }

  loadForm() {
    this.pythonManageForm = this.formBuilder.group({
      name: ['', Validators.required],
      settingName: ['',Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      script: ['']
    })
  }

  get f() { return this.pythonManageForm.controls; }

  onPythonData() {
    this.submitted = true;
    if (this.pythonManageForm.invalid) {
      return;
    }
    if (!/^[^:|*?<>/\"]+$/.test(this.pythonManageForm.value.name)) {
      this.toastrService.clear();
      this.toastrService.error('Python script name is not valid');
      return;
    }
    var objFormval = this.pythonManageForm.value;
    if (this.updateForm === true) {
      const ValueForUpdate = {
        id: this.scriptDataById[0].id,
        name: objFormval.name,
        settingName: objFormval.settingName,
        script: objFormval.script,
        projectId: this.projectId,
      }

      this.dataService.updatePythonScripts(ValueForUpdate).subscribe((data) => {
        if (data) {
          this.testData = data;
          this.getTestData();
          this.ClearForm();
          this.toastrService.clear();
          this.toastrService.success(' Python Scripts Update Successfully')
          this.updateForm = false;
        }
      });
    }
    else if (this.updateForm == false) {
      const ValueForAdd = {
        name: objFormval.name,
        settingName: objFormval.settingName,
        script: objFormval.script,
        projectId: this.projectId,
      }

      this.dataService.addPythonScripts(ValueForAdd).subscribe((data) => {
        if (data) {
          this.getTestData();
          this.ClearForm();
          this.toastrService.clear();
          this.toastrService.success('Python Scripts Saved Successfully')
        }
      });

    }
  }

  updateScript(id) {
    this.updateForm = true
    let selectedItem = this.testData.filter((f) => f.id === id);
    this.scriptDataById =  JSON.parse(JSON.stringify(selectedItem));
    this.pythonManageForm.patchValue({
      name: selectedItem[0].name,
      settingName: selectedItem[0].settingName,
      script: selectedItem[0].script
    })
  }

  ClearForm() {
    this.updateForm = false;
    this.default = '';
    this.loadForm();
  }

}